export default "__VITE_ASSET__Drh1OZq2__"